module.exports = __webpack_public_path__ + "media/images/icons/flags/SV-f7603edad93113629ad989f01cdc9cbc.svg";